import { Sites } from '@ps/platform-message-framework/common/Sites';
import { required } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import {
  NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
  mustNotContainNumber,
  mustNotContainSymbols,
  noWhiteStartOrEnd
} from '@swf/core/utils/validators';

import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTWCL_Last_name,
  TXTWCL_Please_enter_your_last_nameX,
  TXTWCL_Please_enter_your_surnameX,
  TXTWCL_Surname,
  TXTWCL_The_name_you_have_entered_is_i_ELL
} from './FamilyName.messages.json';

const fieldName = 'lastName';
const maxLength = 50;

const FamilyName = () => {
  const isCAON = useSelector(select.cms.getSiteId) === Sites.CA_ON;

  return (
    <TextInput
      id={fieldName}
      label={isCAON ? TXTWCL_Surname : TXTWCL_Last_name}
      maxLength={maxLength}
      checkDisabled
      validators={[
        noWhiteStartOrEnd,
        required(isCAON ? TXTWCL_Please_enter_your_surnameX : TXTWCL_Please_enter_your_last_nameX),
        mustNotContainNumber(TXTWCL_The_name_you_have_entered_is_i_ELL),
        mustNotContainSymbols(
          NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
          TXTWCL_The_name_you_have_entered_is_i_ELL
        )
      ]}
    />
  );
};

export default FamilyName;
